import { createSlice, Dispatch } from '@reduxjs/toolkit';

import { NOTIFICATION_TYPE } from 'types/general.types';
import { AppDispatch } from 'store/index';

export const SHOW_TIME = 3000;
let timeout: number;

type NotificationSliceType = {
  isShow: boolean;
  type?: NOTIFICATION_TYPE;
  message?: string;
};

export const initialState: NotificationSliceType = {
  isShow: false,
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setErrorNotification: (state, { payload }: { payload: string }) => {
      state.isShow = true;
      state.type = NOTIFICATION_TYPE.ERROR;
      state.message = payload;
    },

    setWarningNotification: (state, { payload }: { payload: string }) => {
      state.isShow = true;
      state.type = NOTIFICATION_TYPE.WARNING;
      state.message = payload;
    },

    setSuccessNotification: (state, { payload }: { payload: string }) => {
      state.isShow = true;
      state.type = NOTIFICATION_TYPE.SUCCESS;
      state.message = payload;
    },

    reset: () => initialState,
  },
});

export default slice.reducer;

export const getNotificationSelector = (state: { notification: NotificationSliceType }) => state.notification;

export const { setErrorNotification, setWarningNotification, setSuccessNotification, reset } = slice.actions;

export const showErrorNotification =
  (msg: string, showTime = SHOW_TIME) =>
  (dispatch: Dispatch) => {
    dispatch(setErrorNotification(msg));
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      dispatch(reset());
    }, showTime);
  };

export const showWarningNotification = (msg: string) => (dispatch: AppDispatch) => {
  dispatch(setWarningNotification(msg));
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = window.setTimeout(() => dispatch(reset()), SHOW_TIME);
};

export const showSuccessNotification = (msg: string) => (dispatch: AppDispatch) => {
  dispatch(setSuccessNotification(msg));
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = window.setTimeout(() => dispatch(reset()), SHOW_TIME);
};
